import { IconBrandGit, IconBrandLinkedin, IconMail, IconNews } from '@tabler/icons-preact';
import { Link } from 'wouter-preact';

import { Logo } from '../components/Logo.tsx';
import css from './HomePage.module.css';

export const HomePage = () => {
  return (
    <div class={css.root}>
      <div class={css.content}>
        <Logo />
        <div class={css.links}>
          <a class={css.link} href="https://sr.ht/~seahax/workshop/sources" target="_blank">
            <IconBrandGit class={css.linkIcon} />
            <span class={css.linkLabel}>Code</span>
          </a>
          <Link class={css.link} href="/blog">
            <IconNews class={css.linkIcon} />
            <span class={css.linkLabel}>Blog</span>
          </Link>
          <a class={css.link} href="https://www.linkedin.com/in/ackermanchris" target="_blank">
            <IconBrandLinkedin class={css.linkIcon} />
            <span class={css.linkLabel}>Work</span>
          </a>
          <a class={css.link} href="mailto:chris@seahax.com">
            <IconMail class={css.linkIcon} />
            <span class={css.linkLabel}>Contact</span>
          </a>
        </div>
      </div>
    </div>
  );
};
